'use strict';

var GridStatusDirective = function GridStatusDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-status.html'),
    controller: 'GridStatusController',
    scope: {
      statusActiveValue: '@',
      statusInactiveValue: '@',
      data: '=',
      statusEventName: '@'
    }
  };
};
GridStatusDirective.$inject = [];
module.exports = GridStatusDirective;